import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import {
  ModalV2,
  ModalV2BackButton,
  ModalV2Body,
  ModalV2Header,
} from "../../components/modals/ModalV2";
import AltContactsForm from "./AltContactsForm";
import { DeleteSearchButton } from "../../components/DeleteSearchButton";

interface AltContactsFormModalProps {
  onDelete?: () => void;
  onIncorrectContacts?: () => void;
  onVerify?: () => void;
}

export const AltContactsFormModal = forwardRef<HTMLDialogElement, AltContactsFormModalProps>(
  function AltContactsFormModal({ onDelete, onIncorrectContacts, onVerify }, ref) {
    const { t } = useTranslation();

    return (
      <ModalV2 modalBoxClassName="bg-base-100 max-w-3xl" ref={ref}>
        <div>
          <ModalV2Header className="flex items-center justify-between py-2">
            <div className="flex items-center gap-2">
              <ModalV2BackButton />
              <h3 className="text-xl">{t("immunizations.search_search_incomplete")}</h3>
            </div>
            <DeleteSearchButton onDelete={onDelete} />
          </ModalV2Header>
        </div>
        <ModalV2Body className="bg-base-100 max-md:px-6 pt-4">
          <AltContactsForm onIncorrectContacts={onIncorrectContacts} onVerify={onVerify} />
        </ModalV2Body>
      </ModalV2>
    );
  }
);

export default AltContactsFormModal;
